export class VersionInfo {
    constructor(
        public readonly productionVersion: boolean = false, 
        public readonly version: string = "dev",    // e.g. "v1.0.0", "latest" or "dev"
        public readonly build: number = 0,
        public readonly hash: string = "0000000000000000000000000000000000000000",
        public readonly buildYear: string = new Date().getFullYear().toString(),
        public readonly buildDate: string = new Date().toUTCString()
    ) {}
} 